var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWetMarketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18V16.5175C3 14.6775 4.2552 13.0748 6.04158 12.634L6.27273 12.5769L8.12243 12.1204C9.04124 11.8937 9.84989 11.3485 10.4047 10.5818L10.9091 9.88462L11.0751 9.65518C11.8273 8.6156 13.0326 8 14.3158 8H14.4545H16.6364H17C19.2091 8 21 9.79086 21 12V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18Z",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2659 2.25821C16.9354 1.58505 16.1232 1.30325 15.4502 1.64599C14.7824 1.98604 14.5202 2.80467 14.8483 3.4729L15.5991 5.00238C15.9385 5.6937 15.8431 6.52408 15.359 7.11578C14.1115 8.64042 13.9483 10.799 14.9498 12.499L15.4641 13.3721C15.8452 14.0189 16.6771 14.2354 17.3214 13.8417C17.9601 13.4514 18.1609 12.6156 17.7829 11.974L17.2686 11.101C16.8509 10.3919 16.9199 9.49066 17.4384 8.85702C18.6038 7.43266 18.8297 5.44363 18.0167 3.78768L17.2659 2.25821ZM10.4685 5.71967C10.138 5.04651 9.32588 4.76472 8.65283 5.10746C7.98508 5.4475 7.72285 6.26614 8.05091 6.93437L8.80178 8.46384C9.14117 9.15517 9.04574 9.98554 8.56161 10.5772C7.31411 12.1019 7.15091 14.2604 8.15243 15.9605L8.66677 16.8335C9.04785 17.4804 9.87977 17.6969 10.524 17.3032C11.1627 16.9129 11.3635 16.0771 10.9855 15.4355L10.4712 14.5624C10.0535 13.8534 10.1226 12.9521 10.641 12.3185C11.8065 10.8941 12.0323 8.90509 11.2194 7.24915L10.4685 5.71967Z",
    fill: "black",
    stroke: "#47AD1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWetMarketIcon);
export default __webpack_public_path__ + "static/media/wetMarketIcon.4ed81b4a47ed26dd94e4a817172f439f.svg";
export { ForwardRef as ReactComponent };